import { useState, useEffect } from 'react';
import _ from 'lodash';
import { REQUEST_PARAMS } from '../utilities/constants';

export const useListSearch = (
  initialSearchParam,
  search,
  searchResponseToList,
  checkParameter = () => true
) => {
  const [list, setList] = useState([]);
  const [total, setTotal] = useState(0);

  const [isLoading, setIsLoading] = useState(false);
  const [allLoaded, setAllLoaded] = useState(false);
  const [searchParam, setSearchParam] = useState(() => ({
    ...initialSearchParam,
    limit: REQUEST_PARAMS.parentLimit,
    offset: 0,
  }));

  // 読込処理
  useEffect(
    () => {
      (async () => {
        let isError = false;
        const isAdd = searchParam.offset !== 0;

        setIsLoading(true);

        const clearList = () => {
          setList([]);
          setTotal(0);
        };

        // 追加読込でなければ最初に一覧を消す
        if (!isAdd) {
          clearList();
        }

        if (!checkParameter(searchParam)) {
          isError = true;
        } else {
          const response = await search(searchParam);
          if (response.result) {
            const list = searchResponseToList(response);
            setAllLoaded(_.size(list) < searchParam.limit);
            setList(prev => {
              return isAdd ? [...prev, ...list] : list;
            });
            setTotal(_.get(response, 'data.total', 0));
          } else {
            isError = true;
          }
        }

        if (isError && !isAdd) {
          clearList();
        }
        setIsLoading(false);
      })();
    },
    [searchParam]
  );

  // 検索
  const listSearch = param => {
    setSearchParam({
      ...param,
      limit: REQUEST_PARAMS.parentLimit,
      offset: 0,
    });
  };

  // 無限スクロールの追加読込
  const handleScroll = () => {
    if (!allLoaded) {
      setSearchParam(prev => ({
        ...prev,
        offset: prev.offset + REQUEST_PARAMS.parentLimit,
      }));
    }
  };

  const searchParamClear = () => {
    setSearchParam({
      ...initialSearchParam,
      limit: REQUEST_PARAMS.parentLimit,
      offset: 0,
    });
  };

  return {
    list,
    total,
    isLoading,
    listSearch,
    handleScroll,
    searchParamClear,
  };
};



// WEBPACK FOOTER //
// ./src/components/useListSearch.js